var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-box",class:{'has-text-after': _vm.hastext!==''}},[_c('iframe',{attrs:{"src":_vm.url,"width":"320","frameborder":"0","gesture":"media","allow":"encrypted-media","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }